<template>

	<div class='container'>

		<slot />

	</div>

</template>


<style scoped>

	.container
	{
		max-height: 450px;
		overflow-y: auto;
	}

	.container :slotted(ul)
	{
		list-style: none;
		padding: 0;
		margin: 0;
	}
	.container :slotted(ul li a)
	{
		color: #fff;
		text-decoration: none;
		display: block;
		padding: 4px 8px;
		transition: background 0.3s, color 0.3s;
	}
	.container :slotted(ul li a:hover)
	{
		background: rgba(255,255,255,0.15);
		text-decoration: none;
	}

</style>